import type React from 'react';
import type { ArtifactRendererProps } from './types';

export type ArtifactRenderer = React.FC<ArtifactRendererProps>;

const ARTIFACT_RENDERERS: Record<string, ArtifactRenderer> = {};

export function registerArtifactRenderer(
  type: string,
  renderer: ArtifactRenderer
): void {
  ARTIFACT_RENDERERS[type] = renderer;
}

export function getArtifactRenderer(type: string): ArtifactRenderer | null {
  return ARTIFACT_RENDERERS[type] ?? null;
}
